import { ReactComponent as Node } from '../img/lang/node.svg';
import { ReactComponent as Javascript } from '../img/lang/javascript.svg';
import { ReactComponent as Mongo } from '../img/lang/mongodb.svg';
import { ReactComponent as Mysql } from '../img/lang/mysql.svg';
import { ReactComponent as Php } from '../img/lang/php.svg';
import { ReactComponent as Re } from '../img/lang/react.svg';
import { ReactComponent as Sass } from '../img/lang/sass.svg';
import { ReactComponent as Typesc } from '../img/lang/typescript.svg';

const Lang = () => {
	return (
		<section className="lang">
			<div className="lang_wrapper">
				<div className="lang_group">
					<Re height={100} width={100} />
					<Typesc height={100} width={100} />
					<Javascript height={100} width={100} />
					<Sass height={100} width={100} />
					<Node height={100} width={100} />
					<Mongo height={100} width={100} />
					<Mysql height={100} width={100} />
					<Php height={100} width={100} />
				</div>
			</div>
		</section>
	);
};

export default Lang;
